// 拆分数组
export const splitArray = (arr: any[]) => {
    const oddIndexArray: any[] = [];
    const evenIndexArray: any[] = [];

    arr.forEach((item, index) => {
        if (index % 2 === 0) {
            oddIndexArray.push(item); // 偶数索引
        } else {
            evenIndexArray.push(item); // 奇数索引
        }
    });

    return [oddIndexArray, evenIndexArray];
};
